import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaClone, FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import KanbanAPI from '../../../api/KanbanAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import Const from '../../../util/Constants';
import ApiUiController from '../../../controller/ApiUiController';
import { Badge } from 'react-bootstrap';

// TODO this will show all the created kanban
class KanbanList extends React.Component {

  constructor(props) {
    super(props);
    this.kanbanViews = [];
    this.state = { model: null, inApiCall: true };
    this.path = this.props.match.path

    this.mainModel = reactLocalStorage.getObject(Const.Model);
    this.model = this.mainModel.view;
    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.mainModel.view.fields.model.options = [
      { label: this.mainModel.lead.model_name, value: this.mainModel.lead.model_no },
    ];
  }

  componentDidMount() { if(this.List) KanbanAPI.list(this.onReceived, this.onFail);}
  onFail = () => this.setState({ inApiCall: false });
  onReceived = kanbanViews => { this.kanbanViews = kanbanViews; this.setState({ ...this.state, inApiCall: false }); }

  onValueChange = (field, value) => {
    const model = this.mainModel.view.fields.model.options.find(option => option.value === value);
    this.setState({ ...this.state, model });
  }
  
  confirmDelete = id => {
    const view = this.kanbanViews.find(view => view.id === id);
    const message = `Are you sure you want to delete to ${view.name}`;
    Util.confirmAlert('Delete', message, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      KanbanAPI.delete(view.id, this.onDelete, this.onFail);
    });
  }

  onDelete = () => {
    Util.showNotification('Successful', 'Deleted successfully.', 'success');
    KanbanAPI.list(this.onReceived, this.onFail);
  }

  render() {
    if(!this.List) return null;
    const viewUI = !this.kanbanViews.length 
      ? <tr><td colSpan={9}>No records</td></tr>
      : this.kanbanViews
        .filter(view => !this.state.model || (this.state.model && this.state.model.value === view.model))
        .map((view, _i) => (
          <tr key={`auto_${_i + 1}`}>
            <td>{_i + 1}</td>
            <td>{Display.ModulLabelValue(view.model)}</td>
            <td>{view.name}</td>
            <td>{Display.FieldValue(view, 'type', this.model.fields)}</td>
            <td>{Display.FieldValue(view, 'roles', this.model.fields)}</td>
            <td>{Display.FieldValue(view, 'users', this.model.fields)}</td>
            <td>{Display.ModelLabelValue('user', view.updated_by)}</td>
            <td>{Util.serverStringToDisplayDateTime(view.updated_date)}</td>
            <td>
              { this.Update ?
                <NavLink to={`${this.path}/${view.id}`} >
                  <Badge variant = "warning" size='sm'  className='m-1 p-2 text-white' > <FaPencilAlt  color='#ffffff' /> Edit</Badge>
                </NavLink> : null
              }
              { view.status !== Const.AlwaysActive && this.Delete ?
                  <Badge onClick={() => this.confirmDelete(view.id)} variant = "danger" size='sm'  className='m-1 p-2 text-white' > <FaTrash  color='#ffffff' /> Delete</Badge> 
              : null
              }
            </td>
          </tr>
      ));

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 pb-3"> <h3>Kanban List</h3> </div>
              {/* <div className="col-md-3 text-right pb-3">
                <FieldSelect key="model" id="model" field={this.mainModel.view.fields.model}
                  value={this.state.model} onValueChange={this.onValueChange} inValid={{}} />
              </div> */}
              <div className="col-md-3 text-right pb-3">
                { this.Add &&
                  <NavLink to={`${this.path}/0`} className="buttons success">
                    Add Kanban
                  </NavLink>
                }
              </div>
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Module</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Roles</th>
                      <th>User</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                    <tbody>
                      <ApiUiController inApiCall={this.props.inApiCall}>
                        { viewUI }
                      </ApiUiController>
                    </tbody>
                  </Table>
              </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(KanbanList);
